export const EMAIL_API_ERROR_MSG = 'is not a valid email';
export const EMAIL_ERROR_MSG = 'E-mail non valide';
export const ERROR_MSG =
  'Une erreur est survenue, veuillez réessayer ultérieurement';
export const AUTHOR_SUCCESS_MSG = (isModify: boolean) =>
  `Cet auteur a été correctement ${isModify ? 'modifié' : 'ajouté'}`;
export const DUP_API_ERROR_MSG = 'ER_DUP_ENTRY';
export const AUTHOR_DUP_ERROR_MSG = 'Un auteur au même nom a déjà été créé';

export const AUTHOR_NAME_UPDATE_LIMIT = 250;
export const ONE_TEAM_EMAIL = 'oneproj@prismamedia.com';
export const AUTHOR_NAME_UPDATE_INTRO =
  "Attention, vous allez modifier le nom de l'auteur de :";
export const AUTHOR_NAME_UPDATE_QUESTION =
  "Êtes-vous sûre de vouloir modifier l'auteur ?";
